'use client';
import {translations} from './translations';
import styles from './meeting.module.css';
import {useRouter} from 'next/router';

export default function MeetingNotice() {
    const {locale} = useRouter();
    const t = translations[locale];

    return (
        <div className={styles.page}>
            <div className={styles.paper}>
                <h1 className={styles.title}>
                    {t.title.split('\n').map((line, i) => (
                        <div key={i}>{line}</div>
                    ))}
                </h1>

                <div className={styles.greeting}>
                    <span>{t.greeting_left}</span>
                    <span>{t.greeting_right}</span>
                </div>

                <p className={`${styles.paragraph} ${styles.indent}`}>{t.intro}</p>

                {t.sections.map((s, i) => {
                    const [title, ...rest] = s.split(':');
                    const content = rest.join(':');

                    return (
                        <p key={i} className={`${styles.paragraph} ${styles.indent}`}>
                            <span className={styles.bold}>{title}:</span>
                            {content}
                        </p>
                    );
                })}

                {/* Section 4 */}
                <p className={`${styles.paragraph} ${styles.bold} ${styles.indent}`}>{t.section4_title}</p>

                <p className={`${styles.paragraph} ${styles.bold} ${styles.italic} ${styles.indent}`}>{t.a}</p>
                <p className={`${styles.paragraph} ${styles.indent}`}>{t.a_content}</p>

                <p className={`${styles.paragraph} ${styles.bold} ${styles.italic} ${styles.indent}`}>{t.b}</p>
                {t.b_content.map((item, i) => (
                    <p key={i} className={`${styles.paragraph}  ${styles.indent}`}>
                        {item}
                    </p>
                ))}

                <p className={`${styles.paragraph} ${styles.italic} ${styles.indent}`}>
                    <span className={`${styles.paragraph} ${styles.underline} ${styles.bold}`}>{t.note[0]}</span>
                    {t.note[1]}
                </p>
                <p className={`${styles.paragraph} ${styles.indent} `}>
                    {t.voting}{' '}
                    <a href={t.website} target="_blank" className={styles.link}>
                        {t.website}
                    </a>
                </p>

                <p className={`${styles.paragraph} ${styles.indent}`}>
                    {t.section5_title}
                    {t.section5_content[0]}{' '}
                    <a href={t.website} target="_blank" className={styles.link}>
                        {t.website}
                    </a>
                    {t.section5_content[1]}
                </p>
                <p className={`${styles.paragraph} ${styles.bold}  ${styles.indent}`}>{t.section6_title}</p>

                {t.agenda.map((item, i) => (
                    <p key={i} className={`${styles.paragraph} ${styles.indent}`}>
                        {i === t.agenda.length - 1 ? (
                            <>
                                <span>{item.no}</span>
                                <span>{item.text}</span>
                            </>
                        ) : (
                            <>
                                <span className={styles.number}>{item.no}</span>
                                <a href={item.link} target="_blank" className={styles.agendaLink}>
                                    {item.text}
                                </a>
                            </>
                        )}
                    </p>
                ))}

                <p className={`${styles.paragraph} ${styles.bold} ${styles.indent}`}>{t.support_title}</p>

                {(() => {
                    const [before, ...rest] = t.support_content.split(':');
                    const after = rest.join(':');

                    return (
                        <p className={`${styles.paragraph} ${styles.indent}`}>
                            {before}:<span className={styles.bold}>{after}</span>
                        </p>
                    );
                })()}

                {t.footer.split('\n').map((line, i) => (
                    <p key={i} className={`${styles.paragraph} ${styles.indent}`}>
                        {line}
                    </p>
                ))}
            </div>
        </div>
    );
}
